// @ngInject
Models.ProposalsCollection = function ProposalsCollection(BaseCollection) {

    return Class(BaseCollection, {
            constructor: function constructor() {
                this.constructor.$super.call(this);
                this._collection.__className = 'ProposalsCollection';
                this._collection.__childsType = 'PayableFileTemplateModel';
                this._collection.shouldMergeOnLoad = true;
                return this._collection;
            }
        }
    );
};